
/*!
 * Copyright (C) 2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *		2024-05-17 (jhoward)
 *			- Refactor calendar footer from hotelCalendar.vue to hotelCalendarFooter.vue.
 */

import {defineComponent} from 'vue'

export default defineComponent({
  name: "hotelCalendarFooter",
  emits: ['close'],
  methods: {
    closeCalendar() {
      this.$emit('close');
    },
  }
})
